import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-permission-unauthorized',
    templateUrl: './permission-unauthorized.component.html',
    styleUrls: ['./permission-unauthorized.component.scss'],
    standalone: false
})
export class PermissionUnauthorizedComponent implements OnInit {
  tenant: string;
  RouterSegments = RouterSegments;

  constructor(private router: Router, private authService: AuthService,
     private readonly titleService: Title,
    private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.titleService.setTitle(this.route.snapshot.data.title);
  }

  logout(): void {
    this.authService.logout();
  }
}
